import angular from 'angular';
import logoUploader from './logoUploader';
import brandColorSelector from './brandColorSelector';

export default angular
  .module('mycrmThemeBranding.components', [])
  .component('brandColorSelector', brandColorSelector)
  .component('logoUploader', logoUploader).name;
